import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import LoadingView from '../../shared/LoadingView';
import API from '../../shared/forms/API';
import ApiKeyList from './ApiKeyList';
import ApiKeyCreateForm from './ApiKeyCreateForm';
import ApiKeyCreatedModal from './ApiKeyCreatedModal';

const ApiKeySection = ({ currentUser }) => {
  const [apiKeys, setApiKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [createdKey, setCreatedKey] = useState(null);
  const [revoking, setRevoking] = useState(null);

  useEffect(() => {
    loadApiKeys();
  }, []);

  const loadApiKeys = async () => {
    setLoading(true);
    try {
      const response = await new API().fetch('admin/api-keys');
      if (response.ok) {
        const data = await response.json();
        setApiKeys(Array.isArray(data) ? data : []);
      } else {
        setStatus({ type: 'danger', text: 'Fout bij laden van API keys.' });
      }
    } catch (err) {
      setStatus({ type: 'danger', text: 'Fout bij laden van API keys.' });
    }
    setLoading(false);
  };

  const handleCreateSuccess = (plainKey) => {
    setShowCreateForm(false);
    setCreatedKey(plainKey);
  };

  const handleModalClose = () => {
    setCreatedKey(null);
    loadApiKeys();
  };

  const handleRevoke = async (id) => {
    if (!window.confirm('Weet je zeker dat je deze API key wilt intrekken? Dit kan niet ongedaan worden gemaakt.')) {
      return;
    }

    setRevoking(id);
    setStatus(null);

    try {
      const response = await new API().fetch(`admin/api-keys/${id}`, 'DELETE');
      if (response.ok) {
        setStatus({ type: 'success', text: 'API key ingetrokken.' });
        await loadApiKeys();
      } else {
        setStatus({ type: 'danger', text: 'Fout bij intrekken van API key.' });
      }
    } catch (err) {
      setStatus({ type: 'danger', text: 'Fout bij intrekken van API key.' });
    }

    setRevoking(null);
  };

  if (loading) {
    return (
      <div className="card mb-4">
        <div className="card-body">
          <h4 className="card-title mb-4">API Keys <span className="badge badge-warning float-right">BETA</span></h4>
          <LoadingView className="h2 my-4" />
        </div>
      </div>
    );
  }

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h4 className="card-title mb-4">API Keys <span className="badge badge-warning float-right">BETA</span></h4>
        <p className="mb-3">
          API keys kunnen gebruikt worden om externe systemen toegang te geven tot de API.
          Een key wordt gekoppeld aan de geselecteerde gebruiker en gebruikt dezelfde rechten als die gebruiker.</p>
        <p>
          Bekijk de <a href="/api/doc/public" target="_blank" rel="noopener noreferrer">API documentatie <i
          className="fa fa-external-link"/></a> voor meer informatie.
        </p>

        {status && (
          <div className={`alert alert-${status.type}`}>{status.text}</div>
        )}

        {showCreateForm ? (
          <ApiKeyCreateForm
            currentUser={currentUser}
            onSuccess={handleCreateSuccess}
            onCancel={() => setShowCreateForm(false)}
          />
        ) : (
          <>
            <ApiKeyList
              apiKeys={apiKeys}
              onRevoke={handleRevoke}
              revoking={revoking}
            />
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowCreateForm(true)}
            >
              <i className="fa fa-plus mr-1"/>
              Nieuwe API Key
            </button>
          </>
        )}
      </div>

      {createdKey && (
        <ApiKeyCreatedModal
          apiKey={createdKey}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.user
});

export default connect(mapStateToProps)(ApiKeySection);
